<template>
    <v-dialog v-model="value" scrollable persistent max-width="350px" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{$t('menu.events')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$emit('input', false)">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text id="event-picker-scroll-target">
                <v-layout>
                    <v-flex xs12>
                        <v-text-field
                          @input="searchEvents"
                          append-icon="search"
                          :placeholder="$t('action.search')"
                          v-model="search"
                          clearable
                          clear-icon="close"
                          :loading="searching"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout v-scroll:#event-picker-scroll-target="onScroll" text-xs-center>
                    <v-flex xs12>
                        <v-list
                            two-line
                        >
                            <template
                              v-for="event in events"
                            >
                                <v-list-tile
                                  avatar
                                  :key="event.id"
                                  @click="returnEvent(event)"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title class="font-weight-bold">{{event.title}}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{event.start_time | moment("LLLL")}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-flex>
                </v-layout>
                <v-layout v-if="loading" text-xs-center>
                    <v-flex xs12>
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card-text>
<!--            <v-card-actions>-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-btn color="blue darken-1" flat @click="$emit('input', false)">{{$t('action.cancel')}}</v-btn>-->
<!--            </v-card-actions>-->
        </v-card>
    </v-dialog>
</template>

<script>
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from "~/utils/url-manager"
    import formatter from '~/utils/formatter'
    import axios from 'axios'
    export default {
        props: {
            value: Boolean,         // Set true to show. Do NOT change this name so that we can use v-model in parent components
            title: String,          // Dialog title
        },
        data () {
            return {
                bottomReached: false,
                page: 1,
                loading: true,
                events: [],
                search: '',
                searching: false,
                cancel: () => {},
            }
        },
        watch: {
            value: function(newValue) {
                if (newValue) {
                    //console.log('exclude', this.exclude);
                    this.search = '';
                    this.bottomReached = false;
                    this.getEvents();
                } else {
                    // Reset data
                    this.page = 1;
                    this.loading = true;
                    this.events = [];
                }
            }
        },
        methods: {
            getEvents: _.debounce(function(search) {
                //console.log('getEvents', search);
                let me = this;

                let config = {
                    cancelToken: new axios.CancelToken(function executor(c) {
                        me.cancel = c;
                    })
                };

                let params = {
                    page: me.page,
                    search: search
                };

                //TODO filter events when retrieving events from database intead of filtering from response data
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_event_list'}), params, {
                    'success': function (data) {
                        _.each(data.data, x => {
                            me.events.push(x);
                        });

                        me.loading = false;
                        me.searching = false;
                        if (me.page < data.total_page) {
                            me.bottomReached = false;
                        }
                        me.page++;
                    }
                }, config)
            }, 0),
            searchEvents: _.debounce(function(search) {
                this.cancel();
                this.page = 1;
                this.searching = true;
                this.events = [];
                this.$nextTick(function() {
                    this.getEvents(search);
                });
            }, 500),
            returnEvent(event) {
                this.$emit('success', event);
            },
            onScroll(e) {
                if ((e.target.offsetHeight + e.target.scrollTop) >= e.target.scrollHeight) {
                    // you're at the bottom of the page
                    if (!this.bottomReached) {
                        this.bottomReached = true;
                        this.loading = true;
                        this.getEvents();
                    }
                }
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
</style>